import { render, staticRenderFns } from "./CarouselImages.vue?vue&type=template&id=92dd4db2&scoped=true"
import script from "./CarouselImages.vue?vue&type=script&lang=js"
export * from "./CarouselImages.vue?vue&type=script&lang=js"
import style0 from "./CarouselImages.vue?vue&type=style&index=0&id=92dd4db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92dd4db2",
  null
  
)

export default component.exports